var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__lk-menu-mobile d-sm-none"},[_c('div',{staticClass:"toggle"}),(_vm.$route.name === 'Selection')?[_c('span',[_c('icon-attestation',{attrs:{"fill":"#fff"}}),_vm._v(" Отбор в тренеры")],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }